define('lq/pageLoadEventManager',[
    'underscore'
], function (_) {

    var PageLoadEventManager = function () {
        this.events = [];
        this.current = undefined;
    }

    PageLoadEventManager.prototype.scheduleEvent = function (instanceId, event, callback) {
        this.events.push({
            instanceId,
            event,
            callback
        });
        if (this.events.length === 1) {
            this.startEvent();
        }
    };

    PageLoadEventManager.prototype.startEvent = function () {
        var self = this;
        
        if (this.events.length > 0) {
            this.current = this.events[0];
            this.current.event()
                .then(function (aborted) {
                    if (typeof self.current.callback === "function") self.current.callback();
                    self.current = undefined;
                    
                    if (aborted) {
                        self.events = [];
                    } else {
                        self.events.shift();
                        self.startEvent();
                    }
                });
        }
    };

    PageLoadEventManager.prototype.abortEvents = function (instanceId) {
        this.events = _.filter(this.events, function(scheduledEvent) {
            return scheduledEvent.instanceId !== instanceId;
        })
        
        if(this.current && this.current.instanceId === instanceId) {
            this.current = undefined;
            this.startEvent();
        }
    };

    return new PageLoadEventManager();
});

